import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { WNotificationBarModule, WTableDirectivesModule ,WInputRadioModule, WDialogModule, WFilterModule, WBlockUiModule, WInputCheckboxOneModule, FFacetModule, WActionBarModule, WArticleModule, WBoxModule, WButtonGroupModule, WButtonModule, WEditPanelModule, WFieldModule, WInputTextareaModule, WInputTextModule, WPageHeaderModule, WPageSectionModule, WSectionModule, WSelectManyModule, WSelectOneModule, WSlotModule, WStepModule, WStickyBarModule, WValidationPanelModule, WViewModule, WViewPanelModule } from '@wipo/w-angular';
import { WInputDateModule, WInputFileModule } from '@wipo/w-angular/primeng';
import { TableModule } from 'primeng/table';
import { PaginatorModule } from 'primeng/paginator';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AdditionalPartyComponent } from './component/additional-party/additional-party.component';
import { PartyInformationComponent } from './component/party-information/party-information.component';
import { OfficeHeaderComponent } from './component/office-header/office-header.component';
import { CommonModule } from '@angular/common';
import { DebounceClickDirective } from './directives/debounce-click.directive';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TableModule,
        PaginatorModule,
        FFacetModule,
        WActionBarModule,
        WArticleModule,
        WBoxModule,
        WButtonGroupModule,
        WButtonModule,
        WEditPanelModule,
        WFieldModule,
        WInputTextModule,
        WInputTextareaModule,
        WPageHeaderModule,
        WPageSectionModule,
        WSectionModule,
        WSelectManyModule,
        WSelectOneModule,
        WSlotModule,
        WStepModule,
        WStickyBarModule,
        WViewModule,
        WViewPanelModule,
        WInputFileModule,
        WInputDateModule,
        WValidationPanelModule,
        WInputRadioModule,
        WTableDirectivesModule,
        WDialogModule,
        WBlockUiModule,
        WInputCheckboxOneModule, WFilterModule,
        TranslateModule,
        WNotificationBarModule
    ],
    declarations: [
        AdditionalPartyComponent,
        PartyInformationComponent,
        OfficeHeaderComponent,
        DebounceClickDirective
    ],
    exports: [
        FormsModule,
        ReactiveFormsModule,
        TableModule,
        PaginatorModule,
        FFacetModule,
        WActionBarModule,
        WArticleModule,
        WBoxModule,
        WButtonGroupModule,
        WButtonModule,
        WEditPanelModule,
        WFieldModule,
        WInputTextModule,
        WInputTextareaModule,
        WPageHeaderModule,
        WPageSectionModule,
        WSectionModule,
        WSelectManyModule,
        WSelectOneModule,
        WSlotModule,
        WStepModule,
        WStickyBarModule,
        WViewModule,
        WViewPanelModule,
        WInputFileModule,
        WInputDateModule,
        WValidationPanelModule,
        WInputRadioModule,
        WTableDirectivesModule,
        WDialogModule,
        WBlockUiModule,
        WInputCheckboxOneModule, WFilterModule,
        TranslateModule,
        WNotificationBarModule,
        AdditionalPartyComponent, PartyInformationComponent,
        OfficeHeaderComponent,
        DebounceClickDirective
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class WcommonModule { }





